module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"meta":{"title":"Successfully signed up"},"login":"Login","checking":"Checking verification code","updating":"Updating your account","verified":"Successfully verified","success":"Welcome aboard! You can now login.","error":"Verification error"}}')
  delete Component.options._Ctor
}
